import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button, Divider, Form, Input } from "antd";
import api from "../../api";
import { useAuth } from "../../store/AuthContext";
import { useToast } from "../../components/toast";
import logo from "../../assets/images/logo.png";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, setAuth } = useAuth();
  const toast = useToast();

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const res = await api.login({
        email: values.email.trim(),
        password: values.password,
      });

      if (res?.status === 200) {
        setAuth(res.data.accessToken, res.data.user);
        toast("Амжилттай нэвтэрлээ", "success");
      } else {
        toast(res?.data?.message || "Нэвтрэхэд алдаа гарлаа", "error");
      }
    } catch {
      toast("Сүлжээний алдаа", "error");
    } finally {
      setIsLoading(false);
    }
  };

  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <section className="login-section">
      <div className="wrapper">
        <img src={logo} alt="logo" className="logo" />

        <Divider style={{ borderColor: "#7cb305", color: "#7cb305" }}>
          |
        </Divider>

        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="И-мэйл"
            name="email"
            rules={[
              { required: true, message: "Email бөглөнө үү" },
              { type: "email", message: "Email формат буруу байна" },
            ]}
            style={{ marginBottom: 10 }}
          >
            <Input
              placeholder="-"
              autoComplete="email"
              style={{ minHeight: "45px" }}
            />
          </Form.Item>

          <Form.Item
            label="Нууц үг"
            name="password"
            rules={[{ required: true, message: "Password бөглөнө үү" }]}
          >
            <Input.Password
              placeholder="-"
              autoComplete="current-password"
              style={{ minHeight: "45px" }}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 26 }}>
            <Button
              shape="round"
              type="primary"
              htmlType="submit"
              loading={isLoading}
              size="middle"
              block
            >
              Нэвтрэх
            </Button>
          </Form.Item>
        </Form>
      </div>
    </section>
  );
}
